document.addEventListener("DOMContentLoaded", function () {
  const loadMode = document.body.dataset.loadMode;
  if (loadMode !== "scroll-load") return;

  const productGrid = document.querySelector("#collectionsContent .row");
  if (!productGrid) return;

  const sentinel = document.querySelector("#infinite-scroll-sentinel");
  if (!sentinel) return;

  let loading = false;

  const observer = new IntersectionObserver(async (entries) => {
    if (!entries[0].isIntersecting || loading) return;

    const nextLink = document.querySelector("a[rel='next']");
    if (!nextLink) {
      observer.disconnect();
      sentinel.remove();
      return;
    }

    loading = true;

    try {
      const response = await fetch(nextLink.href);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, "text/html");

      const newProducts = html.querySelectorAll("#collectionsContent .collection-card__wrapper");
      newProducts.forEach((el) => productGrid.appendChild(el));

      const newNextLink = html.querySelector("a[rel='next']");

      // Remove old link if exists
      const oldNext = document.querySelector("a[rel='next']");
      if (oldNext) oldNext.remove();

      // Insert new next link (if any) but hidden
      if (newNextLink) {
        document.body.insertAdjacentHTML("beforeend", `
          <div style="display:none">${newNextLink.outerHTML}</div>
        `);
      } else {
        // No more pages
        observer.disconnect();
        sentinel.remove();
      }

    } finally {
      loading = false;
    }
  });

  observer.observe(sentinel);
});
